// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__dUsHP","btnOffer":"AddProduct_btnOffer__aHOey"};